import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { css } from '@emotion/react';

import { ReactComponent as CheckedIconVS } from 'src/assets/svg/stepper-checked.svg';
import { ReactComponent as CheckedIconHos } from 'src/assets/svg/stepper-checked-hos.svg';
import { getTheme } from 'src/utils/getTheme';

import { StepIconProps } from './types';
import { styles } from './styles';
import { StepEnum } from './constants';

const { isHosTheme } = getTheme();

const CheckedIcon = () => (isHosTheme ? <CheckedIconHos /> : <CheckedIconVS />);

export const StepIcon: FC<StepIconProps> = ({ step, activeStep, stepNumber }) =>
    step < activeStep ? (
        <CheckedIcon />
    ) : (
        <Box css={css(styles.stepIcon, step === activeStep && styles.stepIconActive)}>
            <Typography variant="h4">{stepNumber}</Typography>
        </Box>
    );

export const stepIconWrapper = (step: StepEnum, activeStep: StepEnum, stepNumber: number) => () => (
    <StepIcon step={step} activeStep={activeStep} stepNumber={stepNumber} />
);
